import React from 'react';
import { ApiDocsAccessProvider } from '../contexts/ApiDocsAccessContext';
import ApiDocsPasswordGate from '../components/ApiDocsPasswordGate';
import ApiV2Docs from './ApiV2Docs';

const ProtectedApiV2Docs: React.FC = () => {
  return (
    <ApiDocsAccessProvider>
      <ApiDocsPasswordGate>
        <ApiV2Docs />
      </ApiDocsPasswordGate>
    </ApiDocsAccessProvider>
  );
};

export default ProtectedApiV2Docs;
